module.exports = __webpack_public_path__ + "img/icon_google.06b1a9ff.svg";